import { Description } from "@mui/icons-material";
import axios from "axios";
import { API_BASE_CMS,API_BASE_IMG_URl } from "helper/environment";

export const getCareerAboutOverview = async (uuid: string) => {
  const url =
    `${API_BASE_CMS}/jsonapi/node/career_about/${uuid}` +
    `?include=` +
    `field_featureimage,` +
    `field_featureimage.field_media_image,` +
    `field_driven_grow_power_data,` +
    `field_driven_grow_power_data.field_icon,` +
    `field_driven_grow_power_data.field_icon.field_media_image`;

  const response = await axios.get(url);
  return response.data;
};

//Career core values starts
export const getCareerCoreValues = async (uuid: string) => {
  const url = `${API_BASE_CMS}/jsonapi/node/career_core_values/${uuid}`;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to fetch Career ");
  }

  return response.json();
};
//Career core values ends

//Career diversity starts
export const getCareerDiversity = async (uuid: string) => {
  const url = `${API_BASE_CMS}/jsonapi/node/career_diversity/${uuid}?include=field_image,field_image.field_media_image,field_diversity_counter_data,field_diversity_counter_data.field_icon,field_diversity_counter_data.field_icon.field_media_image,field_diversity_counter_data.field_icon.field_media_svg_image`;

  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch Career Diversity data");

  return response.json();
};
//Career diversity ends


//Career Lifet at hinduja starts



export interface LifeItem {
  id: string;
  description: string;
  image: string;
}

export const getCareerLifeAtHrepl = async (uuid: string) => {
  // 1️⃣ Node + paragraphs
  const nodeRes = await axios.get(
    `${API_BASE_CMS}/jsonapi/node/career_life_at_hinduja/${uuid}?include=field_hinduja_image_with_data`
  );

  const { data, included = [] } = nodeRes.data;

  const paragraphs = included.filter(
    (i: any) =>
      i.type === "paragraph--career_hinduja_image_with_data"
  );

  // 2️⃣ Resolve image + description
  const items: LifeItem[] = await Promise.all(
    paragraphs.map(async (para: any,index:number) => {
      let image = "";
        let imageAlt = "";

      // ✅ CORRECT FIELD: field_photo
      const mediaUrl =
        para.relationships?.field_photo?.links?.related?.href;

    if (mediaUrl) {
        const mediaRes = await axios.get(mediaUrl);
        const media = mediaRes.data.data;

        // ✅ get alt text from media relationship meta
        imageAlt =
          media?.relationships?.field_media_image?.data?.meta?.alt ||
          media?.attributes?.name ||
          "";

        const fileUrl =
          media?.relationships?.field_media_image?.links?.related?.href;

        if (fileUrl) {
          const fileRes = await axios.get(fileUrl);

          image = fileRes.data.data.attributes.uri.url
            ? `${API_BASE_IMG_URl}${fileRes.data.data.attributes.uri.url}`
            : "";
        }
      }

      return {
          id: index+1,

        // ✅ CORRECT FIELD: field_image_description
        description:
          para.attributes?.field_image_description?.processed || "",

        image,
        imageAlt
      };
    })
  );

  return {
    subtitle: data.attributes.field_main_title || "",
    title: data.attributes.title || "",
    status: data.attributes.status ,
    items,
  };
};
//Career Life at hinduja ends
// Career Job Opening API (Correct)
export const getCareerJobByUID = async (uid: string) => {
   const res = await axios.get(
    `${API_BASE_CMS}/jsonapi/node/career_job_opening/${uid}`,
    {
      params: {
         include: "field_career_job_opening,field_career_form_field",
      },
    }
  );

  const { data, included = [] } = res.data;

 
    const formbutton = data.attributes.field_career_form_button || "";
    const mainTitle = data.attributes.field_maintitle || "";
    const subTitle = data.attributes.field_subtitle || "";
    const formTitle = data.attributes.field_career_form_title || "";
  const jobs =
    data.relationships.field_career_job_opening?.data.map(
      (ref: any) => {
        const para = included.find(
          (i: any) =>
            i.type === "paragraph--career_job_portal" &&
            i.id === ref.id
        );
 
        return {
          id: para?.id || "",
          title: para?.attributes?.field_job_title || "",
          location: para?.attributes?.field_ebt_slideshow_title?.value || "",
          Description: para?.attributes?.field_quick_description?.value || "",
        };
      }
    ) || [];
    const formfield =
    data.relationships.field_career_form_field?.data.map(
      (ref: any) => {
        const para = included.find(
          (i: any) =>
            i.type === "paragraph--contact_form_field" &&
            i.id === ref.id
        );
 
        return {
          name: para?.attributes?.field_field_name || "",
          value: para?.attributes?.field_field_value || "",
          placeholder: para?.attributes?.field_placeholder || "",
        };
      }
    ) || [];

  return {
    formTitle,mainTitle,subTitle,formbutton,
    jobs,formfield
  };
  // try {
  //   const res = await axios.get(
  //     `${API_BASE_CMS}/jsonapi/node/career_job_opening/${uid}`,
  //      {
  //     params: {
  //        include: "field_career_job_opening,field_contact_form_field",
  //     },
  //   }
  //   );
  //   return res.data;
  // } catch (error) {
  //   console.error("Error fetching career job:", error);
  //   throw error;
  // }
};
// Career Job Opening API (Correct) ends

export const getCareerFAQ = async (uuid: string) => {
  // 1️⃣ Node + paragraphs
  const nodeRes = await axios.get(
    `${API_BASE_CMS}/jsonapi/node/career_faq/${uuid}?include=field_faq`
  );

  const { data, included = [] } = nodeRes.data;

  const paragraphs = included.filter(
    (i: any) =>
      i.type === "paragraph--careerfaq"
  );

  // 2️⃣ Resolve image + description
  const items: LifeItem[] = await Promise.all(
    paragraphs.map(async (para: any) => {
      

      return {
        id: para.attributes?.drupal_internal__id,

        // ✅ CORRECT FIELD: field_image_description
        question: para.attributes?.field_question || "",
        answer: para.attributes?.field_answer?.value || ""
      };
    })
  );

  return {
    title: data.attributes.title || "",
    status: data.attributes.status ,
    items,
  };
};